module.exports = __webpack_public_path__ + "media/1.a6a05360.mp3";